import { SearchConditionLabelResponse } from '@doda/api-client/aspida/@types';
import { apiClient } from '@doda/api-client/util/apiClient';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { Methods as JobSearchListRequestType } from '@doda/api-client/aspida/api/v1/jobs';
import { QueryOtherParams } from '@doda/common/src/constants/queryParams';
import { SearchConditionLabelQuery } from '@doda/common/src/services/getSearchConditionLabelAPI';

/**
 * RejectedValue
 */
export interface RejectedValue {
  message: string;
  redirect: boolean;
}

export const DISPLAY_NUMBER = 50;

export const fetchSearchLabel = createAsyncThunk<
  SearchConditionLabelResponse,
  {
    headers?: IncomingHttpHeaders;
    query: SearchConditionLabelQuery;
    queryother?: QueryOtherParams;
  },
  {
    rejectValue: RejectedValue;
  }
>('searchLabel/fetchSearchLabel', async ({ headers, query }, thunkAPI) => {
  try {
    const response = await apiClient.api.v1.front.jobs.search.label.$get({
      query,
      config: { headers },
    });
    return response;
  } catch (error) {
    const axiosError = error as AxiosError;
    // バリデーションチェックに失敗した場合
    if (axiosError.response?.status === 400) {
      return thunkAPI.rejectWithValue({
        message: `searchLabel/fetchSearchLabel status 400, api request path: ${decodeURI(
          axiosError.request?.path
        )}`,
        redirect: false,
      });
    }
    return thunkAPI.rejectWithValue({ message: '', redirect: false });
  }
});

export const fetchSaveSearchesSearchLabel = createAsyncThunk<
  SearchConditionLabelResponse,
  {
    headers?: IncomingHttpHeaders;
    params: JobSearchListRequestType['get']['query'];
    optionParam?: JobSearchListRequestType['get']['query'];
  },
  {
    rejectValue: RejectedValue;
  }
>(
  'searchLabel/fetchSaveSearchesSearchLabel',
  async ({ headers, params, optionParam }, thunkAPI) => {
    try {
      const response = await apiClient.api.v1.front.jobs.search.label.$get({
        query: {
          ...params,
          ...optionParam,
        },
        config: { headers },
      });
      return response;
    } catch (error) {
      const axiosError = error as AxiosError;
      // バリデーションチェックに失敗した場合
      if (axiosError.response?.status === 400) {
        return thunkAPI.rejectWithValue({
          message: `searchLabel/fetchSaveSearchesSearchLabel status 400, api request path: ${decodeURI(
            axiosError.request?.path
          )}`,
          redirect: false,
        });
      }
      return thunkAPI.rejectWithValue({ message: '', redirect: false });
    }
  }
);
